import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledTermsDialog = styled.div`
    position: relative;
    width: 550px;
    height: 619px;
    margin: 25px;
    @media ${breakpoints.sm} {
        width: 480px;
    }
    @media ${breakpoints.xs} {
        width: 250px;
        height: 400px;
        margin: 15px;
    }

    .termsFrame {
        width: 100%;
        height: 90%;
        overflow-y: scroll;

        h1 {
            font-size: var(--size-32);
            font-style: normal;
            font-weight: bold;
            line-height: 53px;
            color: var(--color-primary);
        }

        h3 {
            font-size: var(--size-18);
            line-height: 24px;
        }

        p {
            font-size: var(--size-16);
            font-style: normal;
            font-weight: normal;
            line-height: 24px;
            color: var(--color-grey-900);
        }

        li {
            font-size: var(--size-16);
            font-style: normal;
            font-weight: normal;
            line-height: 24px;
            color: var(--color-grey-900);
        }

        @media ${breakpoints.xs} {
            height: 87%;
        }
    }

    .containerButtons {
        position: absolute;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        button {
            max-width: 394px;
        }
    }
`;
